import React, {useEffect, useState} from 'react';
import {CircularProgress} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {User} from "../../../../models/User.model";
import {Page} from "../../../../models/Page";
import {Booking} from "../../../../models/Booking.model";
import AdminBookingService from "../../../../services/adminBooking.service";
import BookingList from "../../common/BookingList.component";


interface Props {
    user: User;
}

const Bookings = ({user}: Props) => {

    const [loading, setLoading] = useState(false);
    const [bookings, setBookings] = useState<Page<Booking>>();
    const history = useHistory();

    //region Handlers

    const fetch = async (page: number) => {
        setLoading(true);
        try {
            const response = await AdminBookingService.getAllBookings(page, 20, undefined, undefined, user.id);
            setBookings(response);
        } catch (e: any) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (user.id) {
            fetch(0);
        }
    }, [user.id])

    //endregion Handlers

    //region UI

    if (loading) {
        return <CircularProgress/>
    }

    return (
        <BookingList
            bookings={bookings}
            onBookingClick={booking => {
                history.push(`/admin/booking/${booking.id}/basic`)
            }}

            onPageChange={page => fetch(page)}
        />
    )

    //endregion UI
}

export default Bookings;